import {useEffect} from "react";
import {Outlet} from "react-router-dom";

import useMediaQuery from "@mui/material/useMediaQuery";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";

// project imports
import Drawer from "./Drawer";
import Header from "./Header";
import Loader from "components/Loader";

import {handlerDrawerOpen, useGetMenuMaster} from "app/menu";
import {useTheme} from "@mui/material/styles";

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
    const {menuMasterLoading} = useGetMenuMaster();
    const downXL = useMediaQuery((theme) => theme.breakpoints.down("xl"));
    const theme = useTheme();

    // set media wise responsive drawer
    useEffect(() => {
        handlerDrawerOpen(!downXL);
    }, [downXL]);

    if (menuMasterLoading) return <Loader/>;

    return (
        <Box sx={{display: "flex", width: "100%", backgroundColor: theme.palette.background.default}}>
            <Header/>
            <Drawer/>

            <Box
                component="main"
                sx={{width: "calc(100% - 260px)", flexGrow: 1, p: {xs: 2, sm: 3}}}
            >
                <Toolbar sx={{mt: "inherit"}}/>
                <Box
                    sx={{
                        ...{px: {xs: 0, sm: 2}},
                        position: "relative",
                        minHeight: "calc(100vh - 110px)",
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: theme.palette.background.default,
                    }}
                >
                    <Outlet/>
                    {/*<Footer />*/}
                </Box>
            </Box>
        </Box>
    );
}
